import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./ProductHistory.css";
import CustomTooltip from "../components/CustomTooltip";
import { formatMoney } from "../utils/formatMoney";
import Breadcrumbs from "../components/Breadcrumbs";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "../axiosSetup";


const API_BASE = process.env.REACT_APP_API_BASE_URL;

const ProductHistory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const product = location.state?.product;
const entitiesLoadedRef = React.useRef(false);
  const [history, setHistory] = useState([]);
  const [filter, setFilter] = useState("");
  const [actionFilter, setActionFilter] = useState("All Actions");
  const [loading, setLoading] = useState(true);
const [priorityCurrency, setPriorityCurrency] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
const [backendTotalPages, setBackendTotalPages] = useState(1);
const [tierCurrency, setTierCurrency] = useState("");
const [entityCurrencyMap, setEntityCurrencyMap] = useState({});


  // ----------------------------------------------------
  // FETCH HISTORY
  // ----------------------------------------------------
  useEffect(() => {
  if (!id) return;

  const loadHistory = async () => {
    try {
      const res = await axios.get(`/product/${id}/versions`, {
        params: {
          page: currentPage,
          limit: rowsPerPage,
        },
      });
      const data = res.data || {};

      setHistory(data.productVersions || []);
      setBackendTotalPages(data.totalPages || 1);
      setPriorityCurrency(data.highestPriorityCurrency || "");   // 👈 store it
    } catch (err) {
      console.error("Failed to load product history:", err);
    } finally {
      setLoading(false);
    }
  };

  loadHistory();
}, [id, currentPage]);
// useEffect(() => {
//   const loadEntities = async () => {
//     try {
//       const res = await fetch(`${API_BASE}/dropdown/entity`, {
//         method: "GET",
//         credentials: "include",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });

//       const data = await res.json();

//       if (Array.isArray(data) && data.length) {
//         // highest number = highest priority
//         const highest = data.reduce((a, b) =>
//           a.priority > b.priority ? a : b
//         );

//         setTierCurrency(highest.currency || "");
//       }
//     } catch (e) {
//       console.error("Failed to load entities", e);
//     }
//   };

//   loadEntities();
// }, []);
useEffect(() => {
  if (entitiesLoadedRef.current) return;
  entitiesLoadedRef.current = true;

  const loadEntities = async () => {
    try {
      const res = await axios.get(`/dropdown/entity`);
      const data = res.data || [];

      if (Array.isArray(data)) {
        const map = {};
        data.forEach(e => {
          if (e.entity && e.currency) {
            map[e.entity] = e.currency;
          }
        });
        setEntityCurrencyMap(map);
      }
    } catch (e) {
      console.error("Failed to load entity currencies", e);
    }
  };

  loadEntities();
}, []);


  // ----------------------------------------------------
  // FILTER
  // ----------------------------------------------------
  const filteredData = history.filter((item) => {
    const text = filter.toLowerCase();

    const matchesFilter =
      item.versionNumber?.toString().toLowerCase().includes(text) ||
      (typeof item.changedBy === "string"
        ? item.changedBy.toLowerCase()
        : item.changedBy?.name?.toLowerCase()
      )?.includes(text) ||
      (item.fieldChanged || "").toLowerCase().includes(text) ||
      item.changeType?.toLowerCase().includes(text);

    const matchesAction =
      actionFilter === "All Actions" ||
      item.changeType?.toLowerCase() === actionFilter.toLowerCase();

    return matchesFilter && matchesAction;
  });

  // ----------------------------------------------------
  // PAGINATION (same as User Management)
  // ----------------------------------------------------
const totalPages =
  backendTotalPages || Math.max(1, Math.ceil(filteredData.length / rowsPerPage));


  // fix: reset page if it becomes invalid
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedData = filteredData;

    // === SET HEADER TITLE & SUBTITLE FOR PRODUCT HISTORY ===
useEffect(() => {
  if (!product) return;

  sessionStorage.setItem("headerTitle", "Product History");
  sessionStorage.setItem(
    "headerSubtitle",
    `${product.productCode} • Complete change history`
  );

  window.dispatchEvent(new Event("header-update"));
}, [product]);
  // ----------------------------------------------------
  // CONDITIONAL RETURN (AFTER all hooks)
  // ----------------------------------------------------
  if (!product) {
    return (
      <div className="ph-container">
        <h2>Product History</h2>
        <p>
          No product selected.{" "}
          <button onClick={() => navigate(-1)}>Go back</button>
        </p>
      </div>
    );
  }
  
const PRICE_FIELDS = [
  "sale.minimumSellPrice",
  "sale.defaultSellPrice",
  "sale.defaultPurchasePrice",
];

const isTierPrice = (field) =>
  /^sale\.sellPriceTiers\[[^\]]+\]\.defaultSellPrice$/.test(field || "");

const isNormalPrice = (field) =>
  PRICE_FIELDS.includes(field);

const formatValue = (value, field) => {
  if (value === null || value === undefined || value === "") return "-";

 if (isTierPrice(field)) {
  const entity = getEntityFromTierField(field);
  const currency = entityCurrencyMap[entity] || "";
  return currency
    ? `${currency} ${formatMoney(value)}`
    : formatMoney(value);
}

  if (isNormalPrice(field)) {
    return `${priorityCurrency} ${formatMoney(value)}`;
  }

  return String(value);
};
const getEntityFromTierField = (field) => {
  const match = field?.match(/\[(.*?)\]/);
  return match ? match[1] : null;
};

  // ----------------------------------------------------
  // RENDER
  // ----------------------------------------------------
  return (
    <div className="ph-outer-frame">
      <Breadcrumbs /> 
      <div className="ph-inner-frame">

        <div className="ph-wrap">
          <div className="ph-wrap-text">
            
            {/* <h2 className="ph-product-title">Product History: {product.productCode}</h2> */}
            {/* <p className="ph-subtitle">Complete change history for this product</p> */}
          </div>
        </div>

        {/* TABLE */}
        <div className="ph-table-frame">
          {loading ? (
            <div style={{ minHeight: "220px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 34, color: "#f50087" }} spin />} />
                <span style={{ color: "#f50087", fontWeight: 600 }}>Loading</span>
              </div>
            </div>
          ) : (
            <table className="ph-table">
              <thead>
                <tr>
                  <th>Version</th>
                  <th>Date & Time</th>
                  <th>Changed By</th>
                  <th>Field Changed</th>
                  <th>Old Value</th>
                  <th>New Value</th>
                  <th>Change Type</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((entry, idx) => (
                    <tr key={idx}>
                      <td>V{entry.versionNumber}</td>
                      <td><CustomTooltip
                          message={new Date(entry.createdAt).toLocaleString()}
                          placement="top"
                          color="#4A1476"
                        >
                          <span className="truncate-cell">
                            {new Date(entry.createdAt).toLocaleString()}
                          </span>
                        </CustomTooltip>
                        </td>
                      <td>
                         <CustomTooltip
                              message={
                                typeof entry.changedBy === "string"
                                  ? entry.changedBy
                                  : entry.changedBy?.name || "-"
                              }
                              placement="top"
                              color="#4A1476"
                            >
                              <span className="truncate-cell">
                                {typeof entry.changedBy === "string"
                                  ? entry.changedBy
                                  : entry.changedBy?.name || "-"}
                              </span>
                            </CustomTooltip>
                      </td>
                      <td> <CustomTooltip
                          message={entry.fieldChanged || "-"}
                          placement="top"
                          color="#4A1476"
                        >
                          <span className="truncate-cell">{entry.fieldChanged || "-"}</span>
                        </CustomTooltip></td>
                      <td> <CustomTooltip
                            message={entry.oldValue || "-"}
                            placement="top"
                            color="#4A1476"
                          >
                            <span className="truncate-cell">
      {formatValue(entry.oldValue, entry.fieldChanged)}
    </span>
                          </CustomTooltip></td>
                      <td> <CustomTooltip
                            message={entry.newValue || "-"}
                            placement="top"
                            color="#4A1476"
                          >
                           <span className="truncate-cell">
      {formatValue(entry.newValue, entry.fieldChanged)}
    </span>
                          </CustomTooltip></td>
                      <td>{entry.changeType}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center", padding: "8px" }}>
                      No matching records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}

          {/* PAGINATION (Same as User Management) */}
          {filteredData.length > 0 && (
            <div className="pagination-wrapper">
              <span className="pg-info">
                Page {currentPage} of {totalPages}
              </span>

              <div className="pg-buttons">
                {/* Previous */}
                <button
                  className="pg-arrow"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  ‹
                </button>

                {/* Number buttons */}
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    className={`pg-number ${currentPage === i + 1 ? "active" : ""}`}
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}

                {/* Next */}
                <button
                  className="pg-arrow"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  ›
                </button>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default ProductHistory;
